import React, { ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';

interface UIEmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
    disabled?: boolean;
  };
}

const UIEmptyState: React.FC<UIEmptyStateProps> = ({
  icon,
  title,
  description,
  action,
}) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      px: 2,
      py: 4,
      textAlign: 'center',
    }}
  >
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'primary.tableBorder',
        borderRadius: '50%',
        display: 'flex',
        height: 56,
        justifyContent: 'center',
        mb: 2,
        width: 56,
        '& svg': {
          color: 'text.secondary',
          fontSize: 28,
        },
      }}
    >
      {icon}
    </Box>
    <Typography
      sx={{
        color: 'text.primary',
        fontSize: 15,
        fontWeight: 500,
        mb: description ? 0.75 : action ? 2 : 0,
      }}
    >
      {title}
    </Typography>
    {description && (
      <Typography
        sx={{
          color: 'text.secondary',
          fontSize: 13,
          lineHeight: 1.5,
          maxWidth: 320,
          mb: action ? 2 : 0,
        }}
      >
        {description}
      </Typography>
    )}
    {action && (
      <Button
        startIcon={action.icon}
        onClick={action.onClick}
        variant="outlined"
        size="small"
        disabled={action.disabled}
      >
        {action.label}
      </Button>
    )}
  </Box>
);

export default UIEmptyState;
